;(function($, undefined){

    var rnn = window.rnn;
    // Initialise Bootstrap plugins

    function eventIsOver (event, o) {
        if ((!o) || o === null) return false;
        var pos = o.offset();
        var ex = event.pageX;
        var ey = event.pageY;
        if (ex > pos.left && ex < pos.left+o.outerWidth() && ey > pos.top+o.outerHeight()-15) {
            return true;
        }
        return false;
    }

    function initBootstrapPlugins() {

        // Kill old-RNN-style location autocomplete
        $.fn.autoCompleteLocation = function () {};
        $('.autocomplete_toggle').remove();

        // Dropdowns
        $('.dropdown-toggle').dropdown();

        // Tabs
        $('*[data-dynamic-tabs]').each(function () {
            var $tabGroup = $(this);
            var controls = [];
            var controlTemplate = _.template('<li class="cell center-text"><a href="#<%= id %>" data-toggle="tab"><%= name %></a></li>');
            var controlsTemplate = _.template('<div class="subnav"><ul class="nav nav-pills nav-tabs display-table"><%= controls %></ul></div>');
            $tabGroup.find('.tab-pane').each(function () {
                var $tab = $(this);
                var id = $tab.attr('id') || '';
                var name = $tab.find('*[data-tab-name]').attr('data-tab-name') || '';
                controls.push(controlTemplate({id: id, name: name}));
            });
            $tabGroup.before(controlsTemplate({controls: controls.join('')}));
        });
        $('a[data-toggle="tab"]')
        .click(function (event) {
            event.preventDefault();
            $(this).tab('show');
        })
        .bind('show', function () {
            rnn.messaging.publish("contentPositionChanging");
        })
        .bind('shown', function () {
            rnn.messaging.publish("contentPositionChanged");
        });

        $('*[data-dynamic-tabs]').each(function() {
            $(this).prev().find('*[data-toggle="tab"]').first().trigger('click');
        });

        // Retrieve data-placement attribute value on tooltips
        var $tooltip = $('[rel=tooltip]'),
            placement = $tooltip.data('placement') || 'bottom';

        // Use data-placement attribute value to initialise the tooltip plugin with the correct placement
        $tooltip.tooltip({
            placement: placement
        });

        // manual override to display tooltip onload when neccessary
        $('[rel=tooltip][data-trigger="manual"][data-onload="show"]').tooltip('show');

        // popover for business's markers (when they exist)
        $(".businessMarker[data-content]").popover({
            placement: 'top', delay: { show: 300, hide: 1000 }
        /*, template: ''*/
        });

        // **** Popover for inline comment bars with user pictures *****

        // There's a trick with popovers where you can make them
        // .css("position","relative")
        // and placement: 'inside top', (or 'in' for v2?)
        // and this allows them to stay open while hoving on them.
        // though a bunch of css tweaking will be needed.

        $(".commentBar a[data-content]").popover({
            placement: 'bottom',
            trigger: "manual",
            template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><p class="popover-title"></p><div class="popover-content"><p></p></div></div></div>'
        }).on("mouseenter", function() {
            $(this).popover("show");
            $(".popover").one("mouseleave", function(e) {
                $(this).hide();
            });
        });
        $(".commentBar").on("mouseleave", function(e) {
            if (eventIsOver(e, $(this)) === false) {
                $(".popover").hide();
            }
        });

        // Carousels
        $('.carousel').each(function(){
            $(this).carousel({
                interval: 7500,
                pause: $(this).data('pause')

            });
        })
        .bind('slide', function () {
            rnn.messaging.publish("contentPositionChanging");
        })
        .bind('slid', function () {
            rnn.messaging.publish("contentPositionChanged");
        });

        //Datepicker
        var datePickers = $('input.datepicker');
        datePickers.length && datePickers.datepicker();

        //Timepicker
        var timePickers = $('input.timepicker, .timepicker input');
        timePickers.length && timePickers.timepicker({'showMeridian':false,'disableFocus':true,'defaultTime':false});
    }

    rnn.modules.register("bootstrapPlugins", {
        init: initBootstrapPlugins
    });

})(jQuery);
